import styled from 'styled-components';
import { Row, Skeleton, Upload } from 'antd';

export const CustomUpload = styled(Upload)`
	width: 100%;

	.ant-upload-select-picture-card {
		height: 185px !important;
		width: 150px !important;
		border-radius: 8px !important;
		border: 1px solid ${({ theme }) => theme.palette.secondary['150']} !important;
		background-color: ${({ theme }) => theme.palette.secondary.white} !important;
	}
`;

export const ImageSkeleton = styled(Skeleton.Image)`
	width: 150px !important;
	height: 185px !important;
	border-radius: ${({ theme }) => theme.border.border_radius.br_md};
`;

export const List = styled(Row)`
	display: flex;
	overflow-x: auto;
	flex-wrap: nowrap;
	padding-bottom: 1%;
	::-webkit-scrollbar {
		width: 1px;
		height: 8px;
	}
	::-webkit-scrollbar-track {
		background: ${({ theme }) => theme.palette.secondary['100']};
	}
	::-webkit-scrollbar-thumb {
		background-color: ${({ theme }) => theme.palette.secondary['150']};
		border-radius: ${({ theme }) => theme.border.border_radius.br_md};
	}
	::-webkit-scrollbar-thumb:hover {
		background: ${({ theme }) => theme.palette.secondary['300']};
	}
`;
